import { boot } from 'quasar/wrappers'
import { Notify } from 'quasar'
import type { QNotifyAction } from 'quasar'

/*
 * Defaults visuais das notificações do painel, num lugar só.
 *
 * Antes viviam hardcoded dentro do src/components/Toast.js, então tudo que
 * chamava $q.notify direto escapava deles e saía com posição e cor diferentes
 * do resto do produto. O Notify concatena `defaults.actions` às actions de cada
 * chamada, então registrar o X aqui o coloca em TODA notificação — inclusive
 * nas que não passam pelo useToast().
 */

/** Recorte do store de localização que este boot consome. */
interface LocalizationState {
  language: string
  [language: string]: unknown
}

interface LocalizationTree {
  general?: { close?: string }
}

function closeLabel (localization: LocalizationState): string | undefined {
  const tree = localization[localization.language] as LocalizationTree | undefined
  return tree?.general?.close
}

export default boot(({ store }) => {
  const localization = () => store.state.localization as LocalizationState

  const closeAction = (): QNotifyAction => ({
    icon: 'close',
    dense: true,
    round: true,
    size: 'sm',
    // Sem `color` de propósito: o QBtn flat herda currentColor, então o X fica
    // legível tanto no fundo vermelho do negative quanto no amarelo do warning
    // (onde o Quasar troca o texto para dark).
    'aria-label': closeLabel(localization())
  })

  const apply = () => Notify.setDefaults({
    position: 'bottom-right',
    timeout: 6000,
    color: 'primary',
    textColor: 'white',
    actions: [closeAction()]
  })

  apply()

  // O aria-label é resolvido uma vez por registro; sem isto ele congelaria no
  // idioma em que o painel foi carregado.
  store.watch(
    (state) => (state as { localization: LocalizationState }).localization.language,
    apply
  )
})
